<template>
  <div>
    <router-link to="/dashboard">
      <v-img
        :src="logoPath()"
        height="40px"
        contain
        style="margin-top: 12px;">
      </v-img>
    </router-link>
    <v-list class="pt-0 menu-list" dense dark>
      <v-list-tile @click="gotoPage('/admin/exchange')" active-class="menu-active" :value="isSelected('/admin/exchange')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-img
            contain
            height="24px"
            position="left"
            src="../static/exchange-close.svg"
          ></v-img>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Fechar Câmbio')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/exchange/list')" active-class="menu-active" :value="isSelected('/admin/exchange/list')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-img
            contain
            height="24px"
            position="left"
            src="../static/exchange-operations.svg"
          ></v-img>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Operações de Câmbio')}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-content class="exchange-operation-icon">
          <v-badge color="#27DABC" v-if="pendingExchangesCount > 0">
            <span slot="badge">{{pendingExchangesCount}}</span>
          </v-badge>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/bank_transaction/list')" active-class="menu-active" :value="isSelected('/admin/bank_transaction/list')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">paid</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transações Bancárias')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/scheduled_bank_transaction/unmatched')" active-class="menu-active" :value="isSelected('/admin/scheduled_bank_transaction/unmatched')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">schedule</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transações Programadas')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/subjects/to_approve')" active-class="menu-active" :value="isSelected('/admin/subjects/to_approve')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">admin_panel_settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Cadastros em Análise')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/subjects')" active-class="menu-active" :value="isSelected('/admin/subjects')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">people_alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Cadastros Aprovados')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/subjects/reproved')" active-class="menu-active" :value="isSelected('/admin/subjects/reproved')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">person_off</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Cadastros Reprovados')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/subjects/search')" active-class="menu-active" :value="isSelected('/admin/subjects/search')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">person_search</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Buscar Cadastros')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/subjects/financial_account_authorization')" active-class="menu-active" :value="isSelected('/admin/subjects/financial_account_authorization')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">manage_accounts</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Solicitações de Criação de Contas')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/wire')" active-class="menu-active" :value="isSelected('/admin/wire')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">hourglass_bottom</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transferências em Espera')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/wire/list')" active-class="menu-active" :value="isSelected('/admin/wire/list')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">credit_score</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transferências Registradas')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/pix_wires')" active-class="menu-active" :value="isSelected('/admin/pix_wires')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">pix</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transferências Pix Genial')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/infractions')" active-class="menu-active" :value="isSelected('/admin/infractions')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">warning</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Infrações')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/chargebacks')" active-class="menu-active" :value="isSelected('/admin/chargebacks')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">local_atm</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Chargebacks')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/config')" active-class="menu-active" :value="isSelected('/admin/config')" v-if="signedIn && admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Configurações')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/admin/smartbank/statement')" active-class="menu-active" :value="isSelected('/admin/smartbank/statement')" v-if="signedIn && admin && isProduction">
        <v-list-tile-action>
          <v-icon color="#27DABC">list_alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Extrato Smartbank')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile selected @click="gotoPage('/dashboard')" active-class="menu-active" :value="isSelected('/dashboard')" v-if="signedIn && !admin && approved">
        <v-list-tile-action>
          <v-icon color="#27DABC">insert_chart_outlined</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Dashboard')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="gotoPage('/transactions')" active-class="menu-active" :value="isSelected('/transactions')" v-if="signedIn && !admin && approved">
        <v-list-tile-action>
          <v-icon color="#27DABC">attach_money</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transações')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/wires')" active-class="menu-active" :value="isSelected('/wires')" v-if="signedIn && !admin && approved">
        <v-list-tile-action>
          <v-icon color="#27DABC">sync_alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Transferências')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-group append-icon="arrow_drop_down" no-action :value="isSelected('/customers') || isSelected('/customers/new') || isSelected('/customers/approved') || isSelected('/customers/reproved') || isSelected('/customers/search')" v-if="signedIn && !admin && approved">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="#27DABC">person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title :title="i18n('Cadastros')">{{i18n('Cadastros')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile @click="gotoPage('/customers')" active-class="menu-active" :value="isSelected('/customers')" v-if="signedIn && !admin && approved">
          <v-list-tile-content>
            <v-list-tile-title :title="i18n('Em aprovação')">{{i18n('Em aprovação')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="gotoPage('/customers/approved')" active-class="menu-active" :value="isSelected('/customers/approved')" v-if="signedIn && !admin && approved">
          <v-list-tile-content>
            <v-list-tile-title>{{i18n('Aprovados')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="gotoPage('/customers/reproved')" active-class="menu-active" :value="isSelected('/customers/reproved')" v-if="signedIn && !admin && approved">
          <v-list-tile-content>
            <v-list-tile-title>{{i18n('Reprovados')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="gotoPage('/customers/search')" active-class="menu-active" :value="isSelected('/customers/search')" v-if="signedIn && !admin && approved">
          <v-list-tile-content>
            <v-list-tile-title>{{i18n('Procurar')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="gotoPage('/customers/new')" active-class="menu-active" :value="isSelected('/customers/new')" v-if="signedIn && !admin && approved">
          <v-list-tile-content>
            <v-list-tile-title>{{i18n('Novo')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-tile @click="gotoPage('/exchange')" active-class="menu-active" :value="isSelected('/exchange')" v-if="signedIn && !admin && approved">
        <v-list-tile-action>
          <v-img
            contain
            height="24px"
            position="left"
            src="../static/exchange-close.svg"
          ></v-img>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Fechar Câmbio')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
          <v-list-tile @click="gotoPage('/exchange/list')" active-class="menu-active" :value="isSelected('/exchange/list')" v-if="signedIn && !admin && approved">
        <v-list-tile-action>
          <v-img
            contain
            height="24px"
            position="left"
            src="../static/exchange-operations.svg"
          ></v-img>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Operações de Câmbio')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/users')" active-class="menu-active" :value="isSelected('/users')" v-if="signedIn && !admin && $root.userAllowedTo('users-list')">
        <v-list-tile-action>
          <v-icon color="#27DABC">account_circle</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Usuários')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/payment/pix_global')" active-class="menu-active" :value="isSelected('/payment/pix_global')" v-if="signedIn && has_global_pix_account">
        <v-list-tile-action>
          <v-icon color="#27DABC">pix</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Pix Global')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="goToExternal('https://docs.facilitapay.com/')" active-class="menu-active" v-if="signedIn && !admin">
        <v-list-tile-action>
          <v-icon color="#27DABC">code</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{i18n('Integração')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="gotoPage('/sign_in')" v-if="!signedIn">
        <v-list-tile-action>
          <v-icon color="#27DABC">arrow_forward</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Login</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="signOut()" v-if="signedIn && isMobile">
        <v-list-tile-action>
          <v-icon color="#27DABC">exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Sair</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>
<script>

export default {
  name: 'Menu',
  data() {
    return {
      admin: false,
      signedIn: false,
      approved: false,
      isMobile: false,
      isProduction: false,
      pendingExchangesCount: 0,
      has_global_pix_account: false
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    signOut() {
      this.$cookies.remove('api_token')
      this.$cookies.remove('email')
      this.$cookies.remove('name')
      this.$cookies.remove('admin')
      this.signedIn = false
      this.gotoPage('/')
    },
    isSelected(path) {
      return this.$route.path == path
    },
    gotoPage(path) {
      this.$router.push(path).catch(err => {})
    },
    goToExternal(url) {
      window.open(url, '_blank')
    },
    logoPath() {
      if (this.isProduction) return '/static/facilitapay-logo-color.png'
      return '/static/facilitapay-dev-dark.png'
    },
  },
  mounted() {
    this.$root.store.getCompany((company) => {
      if (company) {
        if (company.clearance_level > 0) {
          this.approved = true
        }
        if (company.partners_config) {
          if (company.partners_config.global_pix_bank_account_id != null){
            this.has_global_pix_account = true
          }
        }
      }
    }, (_error)=>{})

    this.isMobile = this.$vuetify.breakpoint.xs
    this.signedIn = this.$cookies.isKey('api_token') && this.$cookies.get('api_token') !== ''
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    this.isProduction = this.$root.getEnvironment() === 'prod'

    if (this.admin) {
      this.pendingExchangesCount = this.$root.store.pendingExchangesCount

      this.$root.$on('exchangeApproved', () => { this.pendingExchangesCount -= 1 })
      this.$root.$on('updatePendingExchangesCount', (amount) => {
        this.pendingExchangesCount = amount
      })
    }
  }
}

</script>
<style>
.menu-list {
  margin-top: 84px;
}
.exchange-operation-icon{
  width: 20px;
}
.menu-list .v-list__tile__title {
  font-family: 'Paralucent';
  font-weight: 500;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/Menu.vue